import { ReactNode } from 'react';
import styles from './Input.module.scss';

const Input = (props: {
    value: string;
    name: string;
    label?: string;
    placeholder?: string;
    maxLength?: number;
    autoFocus?: boolean;
    fullWidth?: boolean;
    icon?: ReactNode;
    handleChange?: any;
    handleKeyDown?: any;
    handleBlur?: any;
    onRenameConfirmedButtonClicked?: any;
}) => {
    return (
        <div
            className={`${styles.wrap} ${
                props.fullWidth ? styles.fullWidth : ''
            } ${props.icon ? styles.withIcon : ''}`}
            onBlur={props.handleBlur}
        >
            {props.label && <label htmlFor={props.name}>{props.label}</label>}
            {props.icon && <span className={styles.icon}>{props.icon}</span>}
            <input
                name={props.name}
                value={props.value}
                onChange={props.handleChange}
                onKeyDown={props.handleKeyDown}
                autoFocus={props.autoFocus ?? false}
                maxLength={props.maxLength}
                placeholder={props.placeholder || ''}
                style={{
                    width: '100%',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    resize: 'none',
                }}
            />
        </div>
    );
};

export default Input;
